import React, { useState } from 'react';
import { Slider, Typography } from '@mui/material';
import {useSelector} from "react-redux";
import {selectSearchParams} from "../../app/store";

const TimeRangeSlider = ({handleTimeRangeChange}) => {
    const { selectedTimeRange } = useSelector(selectSearchParams);
    // Time intervals to map the slider value to
    const timeIntervals = [
        'Live',
        'Last Hour',
        'Last 2 Hours',
        'Last 4 Hours',
        'Last 12 Hours',
        'Last 24 Hours',
        'Last 2 Days',
        'Last 3 Days',
        'Last Week',
        'Last Month'
    ];


    // State to hold the current slider value
    //const [value, setValue] = useState(timeIntervals.indexOf(selectedTimeRange));

    // Handle the slider value change
    const handleSliderChange = (event, newValue) => {
        //setValue(newValue);
        handleTimeRangeChange(timeIntervals[newValue])
    };

    return (
        <div style={{ width: '100%', maxWidth: 280, margin: '0 auto', textAlign: 'center', padding: '0 4px', boxSizing: 'border-box' }}>
            <Slider
                value={timeIntervals.indexOf(selectedTimeRange)}
                onChange={handleSliderChange}
                step={1}
                marks
                min={0}
                max={9}
                sx={{
                    // General slider color
                    color: '#FF6B35',

                    // Custom thumb styles (the handle of the slider)
                    '& .MuiSlider-thumb': {
                        height: 20, // Height of the thumb
                        width: 20,  // Width of the thumb
                        backgroundColor: '#FF6B35',
                        borderRadius: '50%', // Set this to '0%' for square edges
                        border: '2px solid white', // Border around the thumb
                        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.3)', // Shadow effect on thumb
                        '&:hover': {
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)' // Bigger shadow on hover
                        }
                    },

                    // Custom track styles (filled part)
                    '& .MuiSlider-track': {
                        height: 8, // Thickness of the track
                        borderRadius: '4px', // Rounded track
                        backgroundColor: '#FF6B35',
                    },

                    // Custom rail styles (unfilled part)
                    '& .MuiSlider-rail': {
                        height: 8, // Thickness of the rail
                        borderRadius: '4px', // Rounded rail
                        backgroundColor: '#ccc', // Unfilled track color
                    }
                }}
            />
            <Typography style={{ width: '100%', textAlign: 'center', fontSize: '12px', fontWeight: 500, color: '#3C4A5E', marginTop: '-4px' }}>
                {selectedTimeRange}
            </Typography>
        </div>
    );
};

export default TimeRangeSlider;
